import { useEffect, useState } from "react";
import { BASE_URL_TEST } from "../utils/baseUrl";

/**
 * Loads a shop's public details (address, hours, categories, real rating)
 * by id. Works without login or the visitor's location, so it also works for
 * shared links and Google.
 */
const usePublicShop = (id) => {
  const [publicShop, setPublicShop] = useState(null);

  useEffect(() => {
    setPublicShop(null);
    if (!id || !/^\d+$/.test(String(id))) return undefined;

    let cancelled = false;
    fetch(`${BASE_URL_TEST}/api/main/shop/${id}`)
      .then((response) => (response.ok ? response.json() : null))
      .then((responseData) => {
        if (!cancelled && responseData?.data) setPublicShop(responseData.data);
      })
      .catch((error) => console.error("Failed to fetch shop:", error));

    return () => {
      cancelled = true;
    };
  }, [id]);

  return publicShop;
};

export default usePublicShop;
